function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgCompose = function SvgCompose(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Compose' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("g", {
    transform: "translate(4.000000, 1.000000)"
  }, React.createElement("polygon", {
    points: "0 3.2706 0 45.2706 40 45.2706 40 18.2706 38 18.2706 38 43.2716 2 43.2716 2 5.2716 22 5.2716 22 3.2706"
  }), React.createElement("g", {
    transform: "translate(14.000000, 0.270900)"
  }, React.createElement("path", {
    d: "M15.3418,6.8401 L19.8178,9.4241 L21.4458,6.6041 C21.7908,6.0061 21.8828,5.3101 21.7038,4.6431 C21.5258,3.9761 21.0978,3.4191 20.4998,3.0741 C19.2648,2.3611 17.6818,2.7861 16.9698,4.0201 L15.3418,6.8401 Z M4.4458,25.7941 L8.9208,28.3781 L18.8518,11.1761 L14.3768,8.5921 L4.4458,25.7941 Z M3.8788,27.7761 L3.1828,33.1491 L7.4878,29.8601 L3.8788,27.7761 Z M0.5818,37.6531 L2.1138,25.8331 L13.1228,6.7651 L13.0878,6.7451 L15.2378,3.0201 C16.5018,0.8311 19.3108,0.0781 21.4998,1.3421 C22.5608,1.9541 23.3188,2.9431 23.6358,4.1261 C23.9528,5.3081 23.7908,6.5441 23.1778,7.6041 L21.5498,10.4241 L21.5848,10.4441 L10.0528,30.4171 L0.5818,37.6531 Z"
  }))));
};

SvgCompose = pure(SvgCompose);
SvgCompose.displayName = 'SvgCompose';
export default SvgCompose;